<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'
import { title } from '@/src/router/views/pages/requests/chartOptions'

export default {
  name: 'EditCompanyUser',
  props: {
    rowId: { type: [String, Number], default: null },
  },
  components: { Multiselect },
  data() {
    return {
      rowIdC: this.rowId,
      loadingData: false,
      name: '',
      address: '',
      phone: '',
      currency: { id: null, name: null },
      country: { id: null, name: null },
      countries: [],
    }
  },
  computed: {},
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loadingData = true
      axiosGetPost('get', `/management/companyUser/get/${this.rowIdC}`).then(
        (response) => {
          this.name = response.name
          this.address = response.address
          this.phone = response.phone
          this.currency = response.currency
          this.country = response.country
        }
      )
      axiosGetPost('get', 'cargofive/get_countries').then((response) => {
        if (response.status) {
          this.countries = response.data.countries
        } else {
          this.$toastr.e('Attention. Error ' + response.message)
        }
        this.loadingData = false
        return response
      })
    },
    validateFields() {
      const values = ['name', 'address', 'phone']
      values.forEach((element) => {
        if (!this[element]) {
          this.$toastr.e('Attention. Fill all fields ' + element)
          return false
        }
      })
      if (this.country.id == null) {
        this.$toastr.e('Attention. Select a country')
        return false
      }
      if (this.currency.id == null) {
        this.$toastr.e('Attention. Select a currency')
        return false
      }
      return true
    },
    save() {
      if (this.validateFields()) {
        this.loadingData = true
        axiosGetPost('put', `/management/companyUser/update/${this.rowIdC}`, {
          name: this.name,
          address: this.address,
          phone: this.phone,
          currency: this.currency,
          country: this.country,
        }).then((response) => {
          if (response.success) {
            this.$toastr.s(response.message)
          } else {
            this.$toastr.e('Attention. Error' + response.message)
          }
          this.loadingData = false
          this.$emit('update_view')
          this.$emit('close_modal')
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group w-100">
        <div class="col-md-12 row">
          <div class="col-md-6">
            <label class="mb-1 mt-0" for="name-name">Name </label>
            <b-form-input
              :id="'name-name'"
              v-model="name"
              value
              :placeholder="'Write value name'"
              disabled
            ></b-form-input>
          </div>
          <div class="col-md-6">
            <label class="mb-1 mt-0" for="name-address">Address </label>
            <b-form-input
              :id="'name-address'"
              v-model="address"
              value
              :placeholder="'Write value address'"
              disabled
            ></b-form-input>
          </div>
        </div>

        <div class="col-md-12 row">
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="name-phone">Phone </label>
            <b-form-input
              :id="'name-phone'"
              v-model="phone"
              value
              :placeholder="'Write value phone'"
              disabled
            ></b-form-input>
          </div>
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="name-currency">Currency </label>
            <multiselect
              :id="'name-currency'"
              v-model="currency"
              :options="[]"
              placeholder="Select one "
              label="name"
              track-by="name"
              disabled
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label class="mb-1" for="name-country">Country </label>
            <multiselect
              :id="'name-country'"
              v-model="country"
              :options="countries"
              placeholder="Select one "
              label="name"
              track-by="name"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="col-md-12 row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>
      <div class="col-md-12 row">
        <div class="col-md-12">
          <b-button
            variant="primary"
            class="form-control col-md-4"
            @click="save()"
            >Updated</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
